import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export class SquadflixLinkingApi {
    static async generateLinkCode({deviceId}) {
        const fn = new ApiFunction('generateLinkCode', ChatbotApi.baseUrl);
        return fn.call({deviceId});
    }

    static async getOwnerUserDetails({deviceId, uid}) {
        const fn = new ApiFunction('getOwnerUserDetails', ChatbotApi.baseUrl);
        return fn.call({deviceId, uid});
    }

    static async linkDevice({code}) {
        const fn = new ApiFunction('linkDevice', ChatbotApi.baseUrl);
        return fn.call({code});
    }

    static async confirmLinking({id, name, location, type}) {
        const fn = new ApiFunction('confirmLinking', ChatbotApi.baseUrl);
        return fn.call({id, name, location, type});
    }

    static async getUserDevices() {
        const fn = new ApiFunction('getUserDevices', ChatbotApi.baseUrl);
        return fn.call({});
    }

    static async deleteDevice({deviceId}) {
        const fn = new ApiFunction('deleteDevice', ChatbotApi.baseUrl);
        return fn.call({deviceId});
    }
}
